<script setup>
import PlayerCard from "~/components/players/PlayerCard.vue";
import {useStatConverters} from "~/composables/useStatConverters";

// One leaderboard table: Member | Wins | Win % | Played.
// Rows are {id, player, wins, total, percentage}.
defineProps({
  rows: {type: Array, required: true},
  emptyText: {type: String, default: 'No results yet'},
});

const {doubleToPercentage} = useStatConverters();
</script>

<template>
  <div class="omx-card tl-card">
    <div class="omx-head">
      <div class="omx-member">Member</div>
      <div class="omx-num">Wins</div>
      <div class="omx-num">Win %</div>
      <div class="omx-num">Played</div>
    </div>
    <div v-if="!rows.length" class="omx-empty">{{ emptyText }}</div>
    <div v-for="row in rows" :key="row.id" class="omx-row">
      <div class="omx-member"><player-card :player="row.player"/></div>
      <div class="omx-num">{{ row.wins }}</div>
      <div class="omx-num">{{ doubleToPercentage(row.percentage) }}</div>
      <div class="omx-num">{{ row.total }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.omx-card {
  overflow: hidden;
}

.omx-head,
.omx-row {
  display: flex;
  align-items: center;
  padding: 9px 16px;
}

.omx-head {
  border-bottom: 1px solid rgb(var(--v-theme-borderLight));
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: rgb(var(--v-theme-textSubtle));
}

.omx-row + .omx-row {
  border-top: 1px solid rgb(var(--v-theme-borderLight));
}

.omx-member {
  flex: 1;
  min-width: 0;
}

.omx-num {
  width: 60px;
  flex-shrink: 0;
  text-align: right;
  font-size: 12.5px;
  font-weight: 700;
}

.omx-head .omx-member {
  text-align: left;
}

.omx-empty {
  padding: 16px;
  font-size: 12.5px;
  color: rgb(var(--v-theme-textSubtle));
}

/* compact the embedded PlayerCard so rows stay tight */
.omx-member :deep(.team-card-name--small) {
  font-size: 12.5px;
}
</style>
